package uz.ferro.erp.ui.table

import web.cssom.Color

data class RowItem(
    val key: String,
    val cells: List<CellItem>,
    val onItemClick: (() -> Unit)? = null,
    val onContextMenu: ((Int, Int) -> Unit)? = null,
    val backgroundColor: Color? = null
)
